import React from 'react';
import { PageHeading } from 'src/components/layout/PageHeading';

type PageShellProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Optional right-aligned header controls (e.g. a Save button). */
  actions?: React.ReactNode;
  children: React.ReactNode;
};

/**
 * Standard authenticated-page scroll container + max-width + heading, matching
 * the self-service home shell. The single shell every migrated portal surface
 * uses (account, settings, …).
 */
export const PageShell: React.FC<PageShellProps> = ({
  title,
  subtitle,
  actions,
  children,
}) => (
  <div className="wh-ui block min-h-0 min-w-0 flex-1 overflow-y-auto">
    <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-8 px-6 py-8 lg:px-8">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <PageHeading title={title} subtitle={subtitle} />
        {actions}
      </div>
      {children}
    </div>
  </div>
);
